import React from "react";
import Checkbox from "components/Checkbox";
import { useRecoilState } from "recoil";
import {
  iUnderstandState,
  IUnderstandErrorState,
  selectedRooms
} from "states/CheckOutStates/atoms";
import { colors } from "constants/colors";
import { NoWindowContainer } from "./style";

const NoWindowDisclaimerBlock: React.FC = () => {
  const room = useRecoilState(selectedRooms)[0];

  const [checked, setChecked] = useRecoilState(iUnderstandState);
  const [error, setError] = useRecoilState(IUnderstandErrorState);

  // Generate dynamic message
  let text = "";
  if (!room.hasWindows) {
    text =
      "I understand that I am receiving a discounted rate because I am booking a room which does not have a window, and the only natural source of light in this room is a skylight.";

    if (room.name === "Bishop Inside") {
      text =
        "I understand that I am receiving a discounted rate because I am booking a room which does not have a window or a skylight.";
    }
  }

  if (!text) return null; // room has windows → do not show block

  const toggle = () => {
    setChecked((prev) => {
      const value = !prev;
      localStorage.setItem("iUnderstandChecked", value.toString());
      return value;
    });
    setError(false);
  };

  return (
    <NoWindowContainer>
      <div className="termsOfService">
        <Checkbox
          checked={checked}
          error={error}
          borderColor={colors.signInBorderColor}
          onChange={toggle}
          checkboxScale={1.5}
          checkboxGreen={true}
        />

        <div className="text">
          <span className="plainText" onClick={toggle}>
            {text}
          </span>
        </div>
      </div>

      {error && (
        <div className="required">Please confirm statement above and try again.</div>
      )}
    </NoWindowContainer>
  );
};

export default NoWindowDisclaimerBlock;